import styled from "styled-components";

const BlueBack = styled.div`
  background: #5f95e5;
  height: 100rem;
`;

export default BlueBack;
